/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(7006) FIXME: Parameter '$compile' implicitly has an 'any' type.
const Saveable = ($compile, flow, $templateCache, $timeout) => ({
   link(scope: any, element: any) {
      const itemSaveCompletion = function(msg: any) {
      // turn off spinner when save is successful or when save failed
         if (scope.saveditems.contains(scope.document) || (msg.errorMessage && msg.ids.includes(scope.document.id))) {
            return scope.saving = false
         }
      }

      scope.performAction = function(btn: any) {
         if (btn.link) { return }
         // only use openClickTrackLink functionality if btn does NOT contain a link (e.g. client has custom reserve link)
         if (btn.openLink) { return scope.openClickTrackLink(btn.openLink) }
      }

      flow.on('itemSaveCompletion', itemSaveCompletion)

      scope.$on('$destroy', () => {
         return flow.off('itemSaveCompletion', itemSaveCompletion)
      })

      // delay loading the record action buttons to speed up display of results
      return $timeout(function() {
         const recordActions = $compile($templateCache.get('/assets/recordActionsGroup.html'))(scope)
         return angular.element(element).append(recordActions)
      })
   }
})

// @ts-expect-error TS(7006) FIXME: Parameter '$compile' implicitly has an 'any' type.
const Removable = ($compile, localization, $templateCache, $timeout) => ({
   link(scope: any, element: any) {
      scope.isRTL = localization.localization.isRTL
      return $timeout(() => angular.element(element).append($compile($templateCache.get('/assets/removeSavedItem.html'))(scope)))
   }
})

// @ts-expect-error TS(7006) FIXME: Parameter 'menuManagerService' implicitly has an '... Remove this comment to see the full error message
const SavedItemsFolder = (menuManagerService, moreFacetsService) => ({
   replace: true,
   controller: 'SavedItemsCtrl',
   templateUrl: '/assets/savedItemsFolder.html',

   link(scope: any, element: any, attrs: any) {
      scope.hasTooltip = attrs.savedItemsFolder === 'hasTooltip'
      return scope.toggle = function() {
         menuManagerService.closeAllMenuTypeSubMenu()
         return scope.saveditems.toggle()
      }
   }
})

// @ts-expect-error TS(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
const FlashTooltip = ($timeout, flow) => ({
   link(scope: any, element: any) {
      const savedItemsFolder = angular.element(".savedItemsFolder")
      const savedItemsBtn = angular.element("button.savedItemsButton")

      element.on("mouseenter", () => {
         setTipText()
         return savedItemsBtn.trigger("customEvent")
      })

      element.on("mouseleave", () => {
         return savedItemsBtn.trigger("customEvent")
      })

      const isFlashing = () => {
         return savedItemsFolder.hasClass("flashingTooltip")
      }

      var setTipText = () => {
         return scope.tooltipMsg = isFlashing() ? scope.flashTip : scope.regTip
      }

      const toggleTip = () => {
         savedItemsFolder.toggleClass("flashingTooltip")
         setTipText()
         return savedItemsBtn.trigger("customEvent")
      }

      var handleTip = function() {
      // wire up handleTip to the flow service 'once' hook on initial load
         if (flow.auth.user === undefined) { return flow.once('authChange', handleTip) }
         // display the toolTip on initial load only if user is NOT a flow authenticated user
         if (!flow.auth.user.authenticated) {
            $timeout(toggleTip, 0)
            return $timeout(toggleTip, 5000)
         }
      }

      var unbindWatch = scope.$watch('saveditems.items.length', function(value: any) {
         if (value > 0) {
            handleTip()
            return unbindWatch()
         }
      })

      // clean up on destroy
      return scope.$on('$destroy', function() {
         element.off('mouseenter')
         return element.off('mouseleave')
      })
   }
})

angular.module('summonApp.directives')
   .directive('saveable', ['$compile', 'flowService', '$templateCache', '$timeout', Saveable])
   .directive('removable', ['$compile', 'localizationService', '$templateCache', '$timeout', Removable])
   .directive('savedItemsFolder', ['menuManagerService', 'moreFacetsService', SavedItemsFolder])
   .directive('flashTooltip', ['$timeout', 'flowService', FlashTooltip])
